import graphql__acaae47bc2d67c51abf4 from "./__generated__/MapFilterUser_filter.graphql.js";import { graphql, useFragment } from "react-relay";

import MapFilterUserFieldSelect from "./MapFilterUser/MapFilterUserFieldSelect";

const MapFilterUser = props => {
  const filter = useFragment(MapFilterUser_filter, props.filter);
  const { userFields } = filter;

  return (
    <div className="map-filter map-filter-user-field boxes-list">
      {userFields.map(userField => (
        <MapFilterUserFieldSelect key={userField.id} userField={userField} />
      ))}
    </div>
  );
};

const MapFilterUser_filter = graphql__acaae47bc2d67c51abf4;

export default MapFilterUser;
